module.exports = __webpack_public_path__ + "img/kim-robertsen-l.0d4dce5e.jpg";